import { Box, Stack, Tooltip } from '@mui/material';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { HighlightMatchingText } from '@legacy/components/utils/HighlightMatchingText';
import { Typography } from '@legacy/components/mui-components';
import styles from './CompetenceList.module.scss';
import { TCompetence } from './CompetenceList.types';

interface ICompetenceList {
  competenceList: TCompetence;
  noOfCompetenceToDisplay?: number;
  query?: string;
}

export const CompetenceList = ({
  competenceList = [],
  noOfCompetenceToDisplay = 3,
  query,
}: ICompetenceList) => {
  const { t } = useTranslation('assignFlow');

  const sortedList = competenceList.sort((a, b) => b.value - a.value);
  const list = noOfCompetenceToDisplay
    ? sortedList.slice(0, noOfCompetenceToDisplay)
    : sortedList;
  const competenceScore = Array.from({ length: 5 }, (_, i) => i + 1);

  return (
    <Stack gap={0} width="100%">
      {list.length ? (
        list.map((c) => (
          <Tooltip
            disableInteractive
            key={c.id}
            placement="bottom-start"
            slotProps={{
              popper: {
                modifiers: [{ name: 'offset', options: { offset: [6, -12] } }],
              },
            }}
            title={`${c.name} (${c.value})`}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              mx={-2}
              px={2}
              py={1 / 4}
            >
              <Typography variant="label" lineHeight={1.25} noWrap>
                <HighlightMatchingText matchName={query} name={c.name} />
              </Typography>
              <Stack alignItems="center" direction="row" gap={0.5}>
                {competenceScore.map((s) => (
                  <Box
                    key={`filled-${s}`}
                    className={cx(
                      styles.box,
                      s <= c.value ? styles.activeBox : '',
                    )}
                  />
                ))}
              </Stack>
            </Stack>
          </Tooltip>
        ))
      ) : (
        <Typography variant="label" noWrap>
          {t('NoCompetenceAdded')}
        </Typography>
      )}
    </Stack>
  );
};
